
import HttpClientToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { BuscarListadoEnvioParams, BuscarListadoEnvioResponse, GenerarDocumentoListadoEnvioResponse, GenerarListadoEnvioParams, NuevoListadoEnvioResponse, DetalleListadoEnvioResponse, defaultBuscarListadoEnvioResponse, defaultDetalleListadoEnvioResponse, defaultNuevoListadoEnvio, defaultGenerarDocumentoListadoEnvio } from '../../interfaces/notificaciones/ListadoEnvioInterface';

export const NuevoListadoEnvio = ( ) => {

    return new Promise<NuevoListadoEnvioResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/ListadoEnvio/NuevoListadoEnvio', token)
            .then( ({ data } : { data : NuevoListadoEnvioResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultNuevoListadoEnvio, message: error.message } );
            });

        }

    });

}

export const DetalleListadoEnvio = ( id: string ) => {

    return new Promise<DetalleListadoEnvioResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/ListadoEnvio/DetalleListadoEnvio/${ id }`, token)
            .then( ({ data } : { data : DetalleListadoEnvioResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultDetalleListadoEnvioResponse });
            });

        }

    });

}

export const GenerarListadoEnvio = ( params: GenerarListadoEnvioParams ) => {

    return new Promise<GenerarDocumentoListadoEnvioResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ListadoEnvio/GenerarListadoEnvio', params, token)
            .then( ({ data } : { data : GenerarDocumentoListadoEnvioResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultGenerarDocumentoListadoEnvio, message: error.message } );
            });

        }

    });

}

export const FinalizarListadoEnvio = ( id: string ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/ListadoEnvio/FinalizarListadoEnvio/${ id }`, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const BuscarListadoEnvio = ( params: BuscarListadoEnvioParams ) => {

    return new Promise<BuscarListadoEnvioResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ListadoEnvio/BuscarListadoEnvio/', params, token)
            .then( ({ data } : { data : BuscarListadoEnvioResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultBuscarListadoEnvioResponse });
            });

        }

    });

}
